<template>
    <div>
        <h1>Deploy Java to the Cloud</h1>
        <p>Congrats! You now have:</p>
        <ul>
            <li>A great <i>backend API</i> written with a modern framework</li>
            <li>It has <i>unit tests</i> and you have already tested it against an external test suite</li>
        </ul>

        
        <AwsAccount></AwsAccount>

        <h3>Build it</h3>
        <p> Build your  Spring Boot as a <i>.jar</i> or a <i>.war</i> file. </p>

        <h3>Use <i>Elastic Beanstalk</i></h3>
        <p>Create a new application, and select Java as a platform.</p>
        <p>Select <i>Upload your code</i> instead of a sample application</p>
        <p>By default, Spring Boot listens to port 8080, but Elastic Beanstalk connects to port 5000. Solve this problem by go to the configuration of your elastic beanstalk app. <i>Modify Software</i> and add <i>SERVER_PORT</i> in the environment properties, with the value of <i>5000</i>.</p>
        <p>You can choose to either use a single instance, or a a loadbalanced one. If you want to use <i>https</i> then you will need to have the load balancer option.</p>
        <p>To use HTTPS, then modify the load balancer. Add an <i>HTTPS-listener</i> on port <i>443</i> and map it to <i>port 80</i> using <i>HTTP</i> protocol.</p>
        <p>If you need a database, you can either use the <i>Amazon RDS</i> <span class="comment">/* Relational Database Service */</span>, something like <i>DynamoDB</i> or perhaps configure something custom on an <i>EC2</i> instance?</p>
        <p>In the end, you will have and endpoint similar to app-name.gwe9bfheif.eu-north-1.elasticbeanstalk.com that everyone connected to the internet can use!</p>
        <p>If you don't plan to use the API anymore, then please delete the app as it might eventually exceed your AWS free tier.</p>

        <h3>Want to take it one step further?</h3>
        <p>Re-write your app to use <i>AWS Lambda</i> and <i>AWS API Gateway</i> to make it serverless!</p>


        <h3>Voilà! #Tadaaaa!</h3>
        <p>There you have it! <b><i>High-Five!</i></b></p>
        <p>You have succeeded in creating an API in the cloud, perheps even <i>"Serverless"</i> <span class="comment">/* BuzzWordWarning */</span>. If you haven't done anything more, then this should be free for one year.</p>
        <p>Send an email to your collegues, write a few lines in  <a href="https://afitwest.slack.com/archives/CREFZN18C" target="_blank">#serverless-kitchen</a> and show them what you have accomplished!</p>
        <p>Invite some <router-link to="/test">Testers</router-link> to test your app, or level up and <router-link to="/test">Do it yourself</router-link>!</p>
        <p>Invite some <router-link to="/backend">Backenders</router-link> to use your GUI for their backend, or level up and <router-link to="/backend">Do it yourself</router-link>!</p>
        
        
         

    </div>
</template>



<script>
import AwsAccount from '@/components/AwsAccount.vue'

export default {
    name: 'backend',
    components: {

        AwsAccount
    }
}
</script>

<style scoped>

</style>
